import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/branding/Logo-Hanselmann-ohne Slogan_weiss.png")